module.exports = __webpack_public_path__ + "static/media/coaching-small.ad509e1c.png";